import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Menu, Dropdown } from "antd";
import { ReactComponent as Save_icon } from "../../../../assets/img/icons/save.svg";
import Digest from "../../../../assets/img/icons/Digest-email.svg";
import { getQueryAssetId, getQueryCampaignId } from "modules/EmailBrowser/utils";
import { useRouteMatch } from "react-router-dom";
import { updateKeywordsAPI, updateKeywordsForUI } from "../actions";
import { RootState } from "store";
import { useSelector } from "react-redux";
import { setCampaignSmartSourceUpdateKeyword } from "modules/OnBoarding/actions";

type UpdateKeywordsProps = {
  label: "Update Keywords";
  searchTerms: string;
  extendedSearchTerms: string;
  disabled?: boolean;
  savedKeywords?: string;
  isAssetWithoutCampaign?: boolean;
};

const UpdateKeywords: React.FC<UpdateKeywordsProps> = (props: UpdateKeywordsProps) => {
  // adding to check if smartSource onboarding is pending after updating keywords
  const showCampaigsSmartSourceOnBoarding = useSelector((state: RootState) => state.user.campaignsSmartSource);
  const showCampaigsSmartSourceOnBoardingStep = useSelector(
    (state: RootState) => state.user.campaignsSmartSourceStep
  );

  const callUpdateKeywords = () => {
    let allSearchTerms = [...props.searchTerms, ...props.extendedSearchTerms];
    if (!window.location.pathname.includes("/asset") && !window.location.pathname.includes("/editionedit")) {
      updateKeywordsAPI(allSearchTerms, getQueryCampaignId(), 1, props.isAssetWithoutCampaign);
      if (showCampaigsSmartSourceOnBoarding === 1 && showCampaigsSmartSourceOnBoardingStep === 1) {
        setCampaignSmartSourceUpdateKeyword(true);
      }
    } else {
      updateKeywordsAPI(allSearchTerms, getQueryCampaignId(), 0);
      if (props?.isAssetWithoutCampaign) {
        updateKeywordsForUI(allSearchTerms);
      }
    }
  };
  useEffect(() => {
    // disabled =
    //   props.searchTerms !== undefined &&
    //   props.extendedSearchTerms !== undefined &&
    //   JSON.stringify(props.savedKeywords) !== JSON.stringify([...props.searchTerms, ...props.extendedSearchTerms])
    //     ? false
    //     : true;
  }, []);

  return (
    <>
      <Wrapper {...props}>
        <div className="saved-search" onClick={callUpdateKeywords}>
          {props.label}
          <div className="save-icon">
            <Save_icon />
          </div>
        </div>
      </Wrapper>
    </>
  );
};

export default UpdateKeywords;

const Wrapper = styled.div<{ disabled?: boolean }>`
  ${(props) => (props.disabled ? `opacity: 0.5; pointer-events: none;` : "")}
  .saved-search {
    border: 1px solid #dadada;
    border-radius: 8px;
    background: #fff;
    padding: 0 0 0 10px;
    color: #7e7e7e;
    font-size: 16px;
    font-weight: 500;
    font-family: "Roboto", sans-serif;
    line-height: 40px;
    letter-spacing: -0.5px;
    cursor: pointer;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 11px;
      padding: 0 0 0 6px;
      border-radius: 6px;
      line-height: 29px;
      letter-spacing: -0.5px;
    }
    .save-icon {
      border-left: 1px solid #dddddd;
      display: inline-block;
      padding: 0 10px 0 8px;
      margin: 10px 0 10px 5px;
      float: right;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        padding: 0 3px;
        margin: 10px 3px 10px 5px;
      }
      svg {
        float: left;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          width: 10px;
          height: 10px;
        }
      }
    }
  }
`;
